import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenCheckIcon, Clock3Icon, GraduationCapIcon, PresentationIcon } from 'lucide-react';
import { PrimaryButton } from './PrimaryButton';
const checkout = 'https://esl-teacher-ready.impultienda.ar/checkout';
const productImage = 'https://cdn.magicpatterns.com/uploads/54HYaPXG7W1ch1GQdAuNUw/seguridad_e_higiene_(4).png';
const benefits = [[Clock3Icon, 'Save hours of planning'], [GraduationCapIcon, 'Teach with confidence'], [BookOpenCheckIcon, 'Ready-to-use lessons'], [PresentationIcon, 'Perfect for the classroom']];
export function Hero() {
  return <section id="inicio" className="relative overflow-hidden bg-navy-950 px-4 pb-16 pt-12 text-white sm:pb-24 sm:pt-20" data-id="element-79">
      <div className="absolute inset-0 -z-0 bg-[radial-gradient(circle_at_75%_35%,rgba(29,79,140,.7),transparent_30%),radial-gradient(circle_at_20%_85%,rgba(239,184,50,.18),transparent_25%)]" data-id="element-80" />
      <div className="relative z-10 mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55
      }} data-id="element-82">
          <div className="inline-flex items-center gap-2 rounded-full border border-gold-300/60 bg-white/10 px-3 py-1.5 text-xs font-extrabold tracking-[.12em] text-gold-100" data-id="element-83">
            <span className="h-2 w-2 rounded-full bg-gold-300" data-id="element-84" /> COMPLETE ESL
            TEACHING SYSTEM
          </div>
          <h1 className="mt-6 font-display text-4xl uppercase leading-[.98] text-white sm:text-5xl xl:text-6xl" data-id="element-85">
            Plan an entire year of{' '}
            <span className="text-gold-300" data-id="element-86">ESL classes</span> in just minutes
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.93
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.12,
        duration: 0.65
      }} className="relative mx-auto mt-8 w-full max-w-lg" data-id="element-87">
          <div className="absolute left-1/2 top-1/2 h-64 w-64 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold-300/35 blur-[80px]" data-id="element-88" />
          <img src={productImage} alt="ESL Teacher Ready six-volume teaching system" className="relative z-10 mx-auto w-full drop-shadow-2xl" data-id="element-89" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.24,
        duration: 0.5
      }} className="mt-7" data-id="element-90">
          <p className="mx-auto max-w-2xl text-base leading-7 text-blue-100 sm:text-lg" data-id="element-91">
            Get{' '}
            <strong className="text-white" data-id="element-92">
              120 complete, ready-to-teach English lessons
            </strong>{' '}
            designed for ESL and EFL teachers.
          </p>
          <PrimaryButton href={checkout} className="mt-7 w-full sm:w-auto" data-id="element-93">
            GET ESL TEACHER READY NOW
          </PrimaryButton>
          <p className="mt-4 text-xs font-medium text-blue-100" data-id="element-94">
            Instant digital access • Secure payment • 7-day guarantee
          </p>
          <div className="mt-7 grid gap-3 text-left sm:grid-cols-2" data-id="element-95">
            {benefits.map(([Icon, label]) => {
            const BenefitIcon = Icon as typeof Clock3Icon;
            return <div key={label} className="flex items-center gap-3 rounded-xl border border-white/15 bg-white/10 p-3 text-sm font-bold text-white" data-id="element-96">
                  <BenefitIcon size={20} className="shrink-0 text-gold-300" data-id="element-97" />
                  {label}
                </div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}